import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type FiltersState = {
  selectedAnimalSpecies: number | null; // AnimalSpecies.AutoID
  searchTerm: string;
  highlightBookingId: number | null;
  highlightSegmentId: number | null;
};

const initialState: FiltersState = {
  selectedAnimalSpecies: 2,
  searchTerm: "",
  highlightBookingId: null,
  highlightSegmentId: null,
};

const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setSelectedAnimalSpecies(state, action: PayloadAction<number | null>) {
      state.selectedAnimalSpecies = action.payload;
    },
    setSearchTerm(state, action: PayloadAction<string>) {
      state.searchTerm = action.payload;
    },
    setHighlightBookingId(state, action: PayloadAction<number | null>) {
      state.highlightBookingId = action.payload;
    },
    setHighlightSegmentId(state, action: PayloadAction<number | null>) {
      state.highlightSegmentId = action.payload;
    },
  },
});

export const {
  setSelectedAnimalSpecies,
  setSearchTerm,
  setHighlightBookingId,
  setHighlightSegmentId,
} = filtersSlice.actions;
export default filtersSlice.reducer;
